import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from 'src/app/@core/components/ui/button/button.component';
import { ChatSidebarService } from 'src/app/features/chat/services/chat-sidebar.service';
import { DocumentChatTabComponent } from 'src/app/features/chat/components/document-chat-tab/document-chat-tab.component';
import { QnaChatTabComponent } from 'src/app/features/chat/components/qna-chat-tab/qna-chat-tab.component';
import { CompareChatTabComponent } from 'src/app/features/chat/components/compare-chat-tab/compare-chat-tab.component';
import { GeotechnicalChatTabComponent } from 'src/app/features/chat/components/geotechnical-chat-tab/geotechnical-chat-tab.component';
import { AssetUrlPipe } from 'src/app/@shared/pipes/asset-url.pipe';
import { EMBEDDINGS_GENERATION_STATUS } from 'src/app/contract-management/models/contract-management.model';

@Component({
    selector: 'app-chat-sidebar',
    standalone: true,
    imports: [
        CommonModule,
        ButtonComponent,
        DocumentChatTabComponent,
        QnaChatTabComponent,
        CompareChatTabComponent,
        GeotechnicalChatTabComponent,
        AssetUrlPipe,
    ],
    templateUrl: './chat-sidebar.component.html',
})
export class ChatSidebarComponent {
    chatSidebarService = inject(ChatSidebarService);

    get isOpen() {
        return this.chatSidebarService.isOpen;
    }

    get chatType() {
        return this.chatSidebarService.chatType;
    }

    get chatConfig() {
        return this.chatSidebarService.chatConfig;
    }

    get resolvedEmbeddingsStatus(): EMBEDDINGS_GENERATION_STATUS | null {
        const s = this.chatSidebarService.chatConfig().embeddingsStatus;
        return s !== undefined ? s : EMBEDDINGS_GENERATION_STATUS.COMPLETED;
    }
}
